// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-segment {
  --background: none;
  display: flex;
  justify-content: start;
  gap: 5px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  padding: 5px;
}
.content-segment ion-segment-button {
  --indicator-box-shadow: none;
  --color-checked: #ed143d;
  --border-radius: none;
  --border-width: 0;
  --border-color: none;
  --border-style: none;
  --padding-start: 5px;
  --padding-end: 5px;
  min-width: unset;
}
.content-segment ion-segment-button.selectedSegment {
  border-bottom: 2px solid #ed143d;
}

.segment-content-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px 5px;
}
.segment-content-container .text-content .description-text {
  font-size: 16px;
}
.segment-content-container .attachments-content .attachment-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 0;
  border-bottom: 1px solid #e0e0e0;
}
.segment-content-container .attachments-content .attachment-item ion-img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}
.segment-content-container .attachments-content .attachment-item .attachment-icon {
  font-size: 40px;
}
.segment-content-container .attachments-content .attachment-item .attachment-name {
  font-size: 14px;
  font-weight: 600;
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.segment-content-container .attachments-content .attachment-item .attachment-size {
  font-size: 12px;
  color: #6e6e6e;
}
.segment-content-container .attachments-content .attachment-item .download-button {
  --padding-start: 8px;
  --padding-end: 8px;
  --min-height: 32px;
  --min-width: 32px;
  margin: 0;
}
.segment-content-container .attachments-content .attachment-item .download-button ion-icon {
  font-size: 18px;
  color: #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/event-description-modal/event-description-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AACF;AACE;EACE,4BAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,gCAAA;AACN;;AAIA;EACE,OAAA;EACA,gBAAA;EACA,iBAAA;AADF;AAII;EACE,eAAA;AAFN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;AALN;AAOM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AALR;AAQM;EACE,eAAA;AANR;AASM;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAPR;AAUM;EACE,eAAA;EACA,cAAA;AARR;AAWM;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AATR;AAWQ;EACE,eAAA;EACA,cAAA;AATV","sourcesContent":[".modal-content {\n  padding: 16px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.content-segment {\n  --background: none;\n  display: flex;\n  justify-content: start;\n  gap: 5px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n  padding: 5px;\n  \n  ion-segment-button {\n    --indicator-box-shadow: none;\n    --color-checked: #ed143d;\n    --border-radius: none;\n    --border-width: 0;\n    --border-color: none;\n    --border-style: none;\n    --padding-start: 5px;\n    --padding-end: 5px;\n    min-width: unset;\n    \n    &.selectedSegment {\n      border-bottom: 2px solid #ed143d;\n    }\n  }\n}\n\n.segment-content-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 5px;\n  \n  .text-content {\n    .description-text {\n      font-size: 16px;\n    }\n  }\n  \n  .attachments-content {\n    .attachment-item {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      padding: 5px 0;\n      border-bottom: 1px solid #e0e0e0;\n      \n      ion-img {\n        width: 40px;\n        height: 40px;\n        border-radius: 5px;\n      }\n      \n      .attachment-icon {\n        font-size: 40px;\n      }\n      \n      .attachment-name {\n        font-size: 14px;\n        font-weight: 600;\n        flex: 1;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        line-clamp: 2;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        word-break: break-word;\n      }\n      \n      .attachment-size {\n        font-size: 12px;\n        color: #6e6e6e;\n      }\n      \n      .download-button {\n        --padding-start: 8px;\n        --padding-end: 8px;\n        --min-height: 32px;\n        --min-width: 32px;\n        margin: 0;\n        \n        ion-icon {\n          font-size: 18px;\n          color: #ed143d;\n        }\n      }\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
